import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function FailedSolutions() {
  return <section className="py-20 px-6 bg-[var(--bg-deep)]" data-id="element-126">
      <div className="max-w-[680px] mx-auto" data-id="element-127">
        <h2 className="text-3xl md:text-4xl font-serif text-[var(--text-heading)] mb-12 text-center" data-id="element-128">
          Por qué los libros "espirituales" <br data-id="element-129" />
          <span className="text-[var(--text-muted)] italic text-2xl" data-id="element-130">
            a veces te hacen sentir peor
          </span>
        </h2>

        <div className="space-y-8 text-lg text-[var(--text-primary)] leading-relaxed" data-id="element-131">
          <p data-id="element-132">
            La mayoría de los libros espirituales son hermosos. Bien escritos.
            Bien intencionados.
          </p>
          <p data-id="element-133">
            Pero cuando estás en el foso —cuando el dolor no es teórico sino que
            te aprieta el pecho cada mañana— esos libros se sienten{' '}
            <strong className="text-[var(--text-heading)]" data-id="element-134">lejanos</strong>.
            Como consejos de alguien que nunca ha estado donde tú estás.
          </p>

          <div className="grid gap-4 mt-8" data-id="element-135">
            {['Te piden que ores durante horas (tú no tienes ni palabras).', 'Te piden que confíes (tú llevas semanas sin dormir bien).', 'Te piden que seas fuerte (tú solo quieres sobrevivir el día).'].map((item, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-start gap-4 p-4 bg-[var(--bg-elevated)] rounded border border-transparent hover:border-[var(--red-emphasis)]/30 transition-colors" data-id="element-136">
                <X className="w-5 h-5 text-[var(--red-emphasis)] flex-shrink-0 mt-1" data-id="element-137" />
                <p className="text-[var(--text-muted)]" data-id="element-138">{item}</p>
              </motion.div>)}
          </div>

          <div className="mt-12 p-6 border-l-2 border-[var(--red-emphasis)] bg-[var(--red-emphasis)]/5" data-id="element-139">
            <p className="text-[var(--text-heading)] font-serif italic text-xl mb-4" data-id="element-140">
              El susurro del enemigo
            </p>
            <p className="text-[var(--text-muted)]" data-id="element-141">
              En ese silencio de Dios, el enemigo te susurra su mentira más
              cruel: <br data-id="element-142" />
              <span className="text-[var(--text-primary)] font-medium" data-id="element-143">
                "Esto es permanente. No hay salida. Dios se olvidó de ti."
              </span>
            </p>
          </div>

          <p className="text-center text-[var(--accent)] font-medium pt-4" data-id="element-144">
            Ese es el momento más peligroso. No cuando caes. <br data-id="element-145" />
            Sino cuando empiezas a creer que ya no te van a recoger.
          </p>
        </div>
      </div>
    </section>;
}